export default {
    setGroupId: (state, groupId) => {
        return state.set('groupId', groupId);
    },
    setAssigneeIds: (state, assigneeIds) => {
        return state.set('assigneeIds', assigneeIds);
    }
};



// WEBPACK FOOTER //
// ./environments/ticketsgit/core.js